/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LookupKeyEnum {
    PremiumYearly = 'premium-yearly',
    PremiumYearlyAppleIap = 'premium-yearly-apple-iap',
    Premium = 'premium',
    PremiumMonthlyCzk = 'premium-monthly-czk',
    PremiumYearlyCzk = 'premium-yearly-czk',
    PremiumPlusYearlyCzk = 'premium-plus-yearly-czk',
    PremiumMonthlyCzk202411 = 'premium-monthly-czk-2024-11',
    PremiumYearlyCzk202411 = 'premium-yearly-czk-2024-11',
    PremiumMonthlyCzk202605 = 'premium-monthly-czk-2026-05',
    PremiumHalfYearlyCzk202605 = 'premium-half-yearly-czk-2026-05'
}

export function LookupKeyEnumFromJSON(json: any): LookupKeyEnum {
    return LookupKeyEnumFromJSONTyped(json, false);
}

export function LookupKeyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupKeyEnum {
    return json as LookupKeyEnum;
}

export function LookupKeyEnumToJSON(value?: LookupKeyEnum | null): any {
    return value as any;
}

